<template>
  <div>
           <v-row class="payment-property-container">
         <v-col :cols="$vuetify.breakpoint.xs ? 9 : 6" class="pt-3 ml-1">
          <HbSelect
              :value="selectedPropertyId"
              :items="properties"
              placeholder="Select Property"
              id="source_property"
              name="source_property"
              item-value="id"
              :clearable="false"
              @change="selectedPropertyUpdated($event)"
              item-color="#000000"
              color="#000000"
              class="font-weight-medium"
              rounded
          >
            <template v-slot:selection="data">
                <div class="hb-input-overflow pl-4">
                    {{data.item.number}} -  {{data.item.Address.city}}
                </div>
            </template>
            <template v-slot:item="data">
              <div>
                {{data.item.number}} - {{data.item.Address.city}}
              </div>
            </template>
          </HbSelect>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.xs ? 2 : 1" class="pa-0 mt-4" :class="{'d-flex justify-center' : $vuetify.breakpoint.xs}">
            <hb-tooltip>
              <template v-slot:item>
                <hb-icon large mdi-code="mdi-information"></hb-icon>
              </template>
              <template v-slot:body>
                Location where payment is received.
              </template>
            </hb-tooltip>
          </v-col>
      </v-row>
  </div>
</template>


<script type="text/babel">
  import { mapGetters, mapMutations } from "vuex";
import payment from '../../../assets/api/payment';
  import { EventBus } from '../../../EventBus';

  export default {
    data() {
      return {
      }
    },
    computed:{
      ...mapGetters({
        properties: 'propertiesStore/filtered',
        payment: 'paymentsStore/getPayment',
      }),

      selectedPropertyId(){
        return this.payment.property_id;
      },
    },
    props: [],
    created () {
    },
    methods: {
      ...mapMutations({
        setPayment: 'paymentsStore/setPayment',
      }),
      async getErrors() {
        return await this.$validator.validateAll();
      },
      selectedPropertyUpdated(selectedProperty){
        EventBus.$emit('handleSourcePropertyUpdate', selectedProperty,null,null,true);
      }
    }
  }
</script>

<style scoped>
  .hb-select-width-370 {
    max-width: 100% !important;
  }

  .payment-property-container{
    padding-top: 0px !important;
    background: #E0F5F5;
  }
</style>
